import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import {
  exportProvinceIn,
  getProvinceInProjects,
  getProvinceInProvinces,
  getProvinceIns,
  processDistribution,
} from "store/province-in/province-in-action"
import {
  getProvinceItemCategories,
  getProvinceProjects,
  getProvinceProvider,
  getProvinceProvinces,
  getProvinceCurrencies,
} from "store/province-dashboard/province-dashboard-action"
import ProvinceInListComponent from "components/ProvinceIn/list"
import ProvinceInDetailModal from "components/ProvinceIn/details"

const ProvinceInList = () => {
  document.title = "Receipts"

  const dispatch = useDispatch()
  const { data, error, loading, exportStatus, processDistributionStatus } =
    useSelector(state => state.provinceIn)
  const permissions = useSelector(state => state.auth.permissions)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)
  const [pIn, setPIn] = useState(null)
  const [distributionMode, setDistributionMode] = useState(false)

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    const searchWithDistribution = distributionMode
      ? { ...advnacedSearch, distributionMode: true }
      : advnacedSearch

    dispatch(
      getProvinceIns(
        link.url,
        pageNumber,
        according,
        search,
        searchWithDistribution
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProvinceIns(
      undefined,
      undefined,
      undefined,
      search,
      distributionMode
        ? { ...advnacedSearch, distributionMode: true }
        : advnacedSearch
    ),
    search
  )

  // fetch new data based page number, according, or distribution mode changes
  useEffect(() => {
    const searchWithDistribution = distributionMode
      ? { ...advnacedSearch, distributionMode: true }
      : advnacedSearch

    dispatch(
      getProvinceIns(
        undefined,
        pageNumber,
        according,
        search,
        searchWithDistribution
      )
    )
  }, [pageNumber, according, distributionMode])

  // fetch data for filter
  useEffect(() => {
    dispatch(getProvinceItemCategories())
    dispatch(getProvinceInProjects())
    dispatch(getProvinceInProvinces())
    dispatch(getProvinceProvider())
    dispatch(getProvinceCurrencies())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    const searchWithDistribution = distributionMode
      ? { ...data, distributionMode: true }
      : data
    dispatch(
      getProvinceIns(
        undefined,
        undefined,
        undefined,
        search,
        searchWithDistribution
      )
    )
  }

  // Show record details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setPIn(data)
    setDetailModal(true)
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(exportProvinceIn({ advancedSearch: advnacedSearch }))
  }

  // Handle Process Distribution action
  const onProcessDistribution = ids => {
    dispatch(processDistribution(ids))
  }

  // Handle distribution mode toggle
  const onDistributionModeChange = mode => {
    setDistributionMode(mode)
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Province"} breadcrumbItem={"Receipts"} />

      {/* record detail modal  */}
      <ProvinceInDetailModal
        data={pIn}
        open={detailModal}
        setOpen={setDetailModal}
      />
      {/* Province Receipt list component  */}
      <ProvinceInListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
        onProcessDistribution={onProcessDistribution}
        processDistributionStatus={processDistributionStatus}
        distributionMode={distributionMode}
        onDistributionModeChange={onDistributionModeChange}
      />
    </React.Fragment>
  )
}

export default ProvinceInList
